import appSnackbarService from "@/services/appSnackbar.service";

const errorTimeOut = 30000;

export default {
  setSnackBarErrorFromErrorResponse: error => {
    if (
      error.response.data.i18n &&
      error.response.data.i18n === "USER_OR_PASSWORD_INCORRECT"
    ) {
      // don't show when it's login form error
      return;
    }

    // Handle session expired specifically
    if (error.response && error.response.status === 401) {
      appSnackbarService.error("Session expired. Please log in again.", errorTimeOut);
      return;
    }

    if (error.response.data.hasOwnProperty("Message")) {
      appSnackbarService.error(error.response.data.Message, errorTimeOut);
    } else if (error.response.data.hasOwnProperty("error")) {
      appSnackbarService.error(error.response.data.error, errorTimeOut);
    } else if (error.response.data.hasOwnProperty("errors")) {
      if (typeof error.response.data.errors === "object" && error.response.data.errors !== null) {
        // If it's an object, format each error as "Key: Message"
        const formattedErrors = Object.keys(error.response.data.errors).map(key => {
          const errorItem = error.response.data.errors[key];
          if (typeof errorItem === "object" && errorItem.Key && errorItem.Message) {
            return `${errorItem.Key}: ${errorItem.Message}`;
          } else if (typeof errorItem === "string") {
            return `<b>${key}</b>: ${errorItem}`;
          } else if (Array.isArray(errorItem)) {
            return `<b>${key}</b>: ${errorItem.join(", ")}`;
          } else {
            return JSON.stringify(errorItem);
          }
        }).join("<br>");
        appSnackbarService.error(formattedErrors, errorTimeOut);
      } else {
        // If it's a string, show as is
        appSnackbarService.error(error.response.data.errors, errorTimeOut);
      }
    } else {
      appSnackbarService.error("Váratlan hiba!", errorTimeOut);
    }
  }
};
